export default __webpack_public_path__ + "static/media/house-nurse.38d5ae31.svg";